'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { MarketsHowItWorksModal } from '@/components/how-it-works/markets-how-it-works-modal';
import { AnimatedButton } from '@/components/ui/animated-button';
import { HelpCircleIconSolid } from '@/components/ui/icon/glyphs';
import { cn } from '@/lib/ui/utils';
import { useGraduationModalStore } from '@/stores/graduation-modal';
import { useManipulationModalStore } from '@/stores/manipulation-modal';
export function MarketsInfoAction() {
  const $ = _c(20);
  const t = useTranslations("markets_how_it_works");
  const [open, setOpen] = useState(false);
  const openGraduation = useGraduationModalStore(_temp);
  const openManipulation = useManipulationModalStore(_temp2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setOpen(true);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = open && "bg-background-tertiary";
  let t3;
  if ($[3] !== t2) {
    t3 = cn("text-foreground-tertiary hover:bg-background-tertiary", t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== open || $[6] !== t1 || $[7] !== t3) {
    t4 = <AnimatedButton variant="tertiary" size="default" prefix={HelpCircleIconSolid} onClick={t0} aria-label={t1} aria-haspopup="dialog" aria-expanded={open} className={t3} />;
    $[5] = open;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== openGraduation) {
    t5 = () => {
      setOpen(false);
      openGraduation(true);
    };
    $[9] = openGraduation;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== openManipulation) {
    t6 = () => {
      setOpen(false);
      openManipulation(true);
    };
    $[11] = openManipulation;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== open || $[14] !== t5 || $[15] !== t6) {
    t7 = <MarketsHowItWorksModal open={open} onOpenChange={setOpen} onWhatIsGraduation={t5} onPreventManipulation={t6} />;
    $[13] = open;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t4 || $[18] !== t7) {
    t8 = <>{t4}{t7}</>;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function _temp2(state_0) {
  return state_0.setOpen;
}
function _temp(state) {
  return state.setOpen;
}